// extracted by mini-css-extract-plugin
export var brandIcon = "GLsLm";